import api from "@/api/api-v2-config";

export async function getGpsDeviceListAxios() {    
    return await api.get("distributions/gpsdevices?PageNumber=1&PageSize=10000");
}

export async function deleteGpsDeviceAxios(id) {    
    return await api.delete("distributions/gpsdevices?GPSDeviceId=" + id);
}

export async function postGpsDeviceAxios(gpsdevice) {    
    return await api.post("distributions/gpsdevices", gpsdevice);
}

export async function putGpsDeviceAxios(gpsdevice) {    
    return await api.put("distributions/gpsdevices", gpsdevice);
}

export async function getGpsDeviceByIDAxios(id) {    
    return await api.get("distributions/gpsdevices/" + id);
}